export default __webpack_public_path__ + "static/media/2plus 12sept21.8de81626.jpg";